export default __webpack_public_path__ + "static/media/vertical-ellipsis.125d2125.svg";